import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ProductsKeyType {
  addCompanyProduct: LocalesKey;
  threeDStock: LocalesKey;
  aiTagsUpdate: LocalesKey;
  attachSelected: LocalesKey;
  clearProductCache: LocalesKey;
  clearProductsCache: LocalesKey;
  created: LocalesKey;
  clearAllCustomTags: LocalesKey;
  customTags: LocalesKey;
  teamCustomTags: LocalesKey;
  cantChangeTeamCustomTagsMessage: LocalesKey;
  companyProduct: LocalesKey;
  download: LocalesKey;
  downloadModel: LocalesKey;
  duplicate: LocalesKey;
  exploreMyLibrary: LocalesKey;
  my: LocalesKey;
  plural: LocalesKey;
  singular: LocalesKey;
  search: LocalesKey;
  searchCustomTags: LocalesKey;
  searchProductsByNameOrSku: LocalesKey;
  addProduct: LocalesKey;
  attach: LocalesKey;
  attachProduct: LocalesKey;
  all: LocalesKey;
  associatedAssets: LocalesKey;
  associatedLifestyles: LocalesKey;
  assocLifestyles: LocalesKey;
  associatedMaterials: LocalesKey;
  assocMaterials: LocalesKey;
  deleteProduct: LocalesKey;
  deleteWarning: LocalesKey;
  category: LocalesKey;
  editProduct: LocalesKey;
  noPlural: LocalesKey;
  name: LocalesKey;
  imageWithExtensions: LocalesKey;
  selected: LocalesKey;
  similar: LocalesKey;
  showBlocked: LocalesKey;
  viewAll: LocalesKey;
  categories: {
    architecturalPart: LocalesKey;
    equipmentAndDevices: LocalesKey;
    exterior: LocalesKey;
    homeDecor: LocalesKey;
    homeTextiles: LocalesKey;
    kitchen: LocalesKey;
    plants: LocalesKey;
  };
  oneOrMoreSkuWasNotFoundInProductLibrary: LocalesKey;
  recentInMyLibrary: LocalesKey;
  url: LocalesKey;
  uploadToLibrary: LocalesKey;
}

export const productsKeys = keyPathMirror<ProductsKeyType, string>(
  {
    addCompanyProduct: null,
    threeDStock: null,
    aiTagsUpdate: null,
    attachSelected: null,
    clearProductCache: null,
    clearProductsCache: null,
    created: null,
    clearAllCustomTags: null,
    customTags: null,
    teamCustomTags: null,
    cantChangeTeamCustomTagsMessage: null,
    companyProduct: null,
    download: null,
    downloadModel: null,
    duplicate: null,
    exploreMyLibrary: null,
    my: null,
    plural: null,
    singular: null,
    search: null,
    searchCustomTags: null,
    searchProductsByNameOrSku: null,
    addProduct: null,
    attach: null,
    attachProduct: null,
    all: null,
    associatedAssets: null,
    associatedLifestyles: null,
    assocLifestyles: null,
    associatedMaterials: null,
    assocMaterials: null,
    deleteProduct: null,
    deleteWarning: null,
    category: null,
    editProduct: null,
    noPlural: null,
    name: null,
    imageWithExtensions: null,
    selected: null,
    similar: null,
    showBlocked: null,
    viewAll: null,
    categories: {
      architecturalPart: null,
      equipmentAndDevices: null,
      exterior: null,
      homeDecor: null,
      homeTextiles: null,
      kitchen: null,
      plants: null
    },
    oneOrMoreSkuWasNotFoundInProductLibrary: null,
    recentInMyLibrary: null,
    url: null,
    uploadToLibrary: null
  },
  'models.products.'
);
